import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './@core/helpers/auth.guard';
import { ResetPasswordComponent } from './@theme/components';
import { LoginComponent } from './@theme/components/login/login.component';
import { AuthComponent } from './pages/auth/auth.component';
import { AuthRoutes } from './pages/auth/auth.routes';
import { IndexComponent } from './Website/index/index.component';
import { StandartComponent } from './Website/Standart/standart.component';
import { WebsiteRoutes } from './Website/website.routes';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    canActivate: [AuthGuard],
    children: [...AuthRoutes]
  },
  { path: 'preview', component: IndexComponent },
  {
    path: 'expedier',
    pathMatch: 'full',
    children: [...WebsiteRoutes]
  },
  { path: 'Standart/:WebPageID', component: StandartComponent },
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent }
];

export const AppRoutingModule = RouterModule.forRoot(routes, {
  preloadingStrategy: PreloadAllModules,
  scrollPositionRestoration: 'enabled'
});
